import { Empty, Spin } from 'antd';
import React, { Suspense } from 'react';

interface SuspenseWrapperProps {
    children: React.ReactNode;
}

export const SuspenseWrapper: React.FC<SuspenseWrapperProps> = ({ children }) => {
    return (
        <Suspense
            fallback={
                <Spin spinning tip={'Loading ...'}>
                    <Empty />
                </Spin>
            }
        >
            {children}
        </Suspense>
    );
};
